module.exports = __webpack_public_path__ + "static/media/aim_main.d7564868.png";